import moment from 'moment';
import * as Yup from 'yup';

const NAMESPACE = 'SCHOOL';

export const ENDPOINT = 'web-apps/dashboard-school/academic-years';

export const INITIAL_VALUES = {
  years: '',
  semester: '',
  startSemester: '',
  endSemester: '',
  description: '',
};

export const ACADEMIC_YEAR_SCHEMA = Yup.object().shape({
  years: Yup.string().required('Tahun harus diisi'),
  semester: Yup.string().required('Semester harus diisi'),
  startSemester: Yup.date().required('Tanggal Awal Periode harus diisi'),
  endSemester: Yup.date().required('Tanggal Akhir Periode harus diisi'),
  description: Yup.string(),
});

export const FETCH_ACADEMIC_YEAR = `${NAMESPACE}_FETCH_ACADEMIC_YEAR`;

export const YEARS_OPTION = [0, 1, 2, 3, 4, 5].map((item) => ({
  value: `${moment().subtract(item, 'years').format('YYYY')}/${moment()
    .subtract(item - 1, 'years')
    .format('YYYY')}`,
  label: `${moment().subtract(item, 'years').format('YYYY')}/${moment()
    .subtract(item - 1, 'years')
    .format('YYYY')}`,
}));

export const SEMESTER_OPTION = [
  {
    value: 'ganjil',
    label: 'GANJIL',
  },
  {
    value: 'genap',
    label: 'GENAP',
  },
];
